import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from "react-router-dom";
import axios from 'axios';
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import { FaFacebookF, FaTwitter, FaWhatsapp, FaShareAlt, FaTimes } from 'react-icons/fa';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { MdFileDownload } from 'react-icons/md';

import Navbarsec from './Navbarsec';

export default function ItineraryPage() {
  const location = useLocation();
  const itineraryData = location.state;

  const shareTwitter = () => {
    const content = `Check out this awesome itinerary I generated for ${itineraryData.state.destination} using jetsetai!`;
    return content;
  };

  const pdfRef = useRef();

  const shareContent = () => {
    let itineraryText = `Check out this awesome itinerary I generated for ${itineraryData.state.destination} using jetsetai! \n\nDestination: ${itineraryData.state.destination}\n`;
    itineraryText += `\nNumber of Days: ${itineraryData.state.numberOfDays}\n`;

    itineraryData.state.days.forEach((day, index) => {
      itineraryText += `\nDay ${index + 1} (${day.timePeriod}):\n`;
      day.activities.forEach((activity) => {
        itineraryText += `- ${activity.name}: ${activity.description}\n`;
      });
    });
    itineraryText += `\nCheck out more at: jetsetai.vercel.app\n`;

    return itineraryText;
  };

  const downloadPDF = () => {
    const input = pdfRef.current;
    html2canvas(input).then((canvas) => {
      const imagetest = canvas.toDataURL('image/PNG');
      const pdf = new jspdf('p', 'mm', 'a4', true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;
      const imgY = (pdfHeight - imgHeight * ratio) / 2;
      pdf.addImage(imagetest, 'PNG', imgX, imgY, imgWidth * ratio, imgHeight * ratio);
      pdf.save(`${itineraryData.state.destination} itinerary.pdf`);
    });
  };

  const ActivityWithImage = ({ activity }) => {
    const [imageURL, setImageURL] = useState(null);

    useEffect(() => {
      const fetchPlaceImage = async () => {
        try {
          const response = await axios.get(
            `https://jetsetai-server.vercel.app/places-api/maps-api-proxy?input=${activity.name} in ${itineraryData.state.destination}`,
            { responseType: 'arraybuffer' }
          );
          console.log("Image fetched successfully:", response);
          const blob = new Blob([response.data], { type: 'image/jpeg' });
          const url = URL.createObjectURL(blob);
          setImageURL(url);
        } catch (error) {
          console.error('Error fetching place image:', error);
        }
      };

      fetchPlaceImage();
    }, [activity]);

    return (
      <div className="relative">
        {imageURL ? (
          <img
            src={imageURL}
            alt={activity.name}
            className="object-cover w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 shadow-md rounded-md"
            style={{ objectFit: 'cover' }}
          />
        ) : (
          <div className="m-8 rounded shadow-md w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 animate-pulse bg-gray-300"></div>
        )}
      </div>
    );
  };

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);

  if (!itineraryData) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Navbarsec />
      <div className="relative max-w-4xl mx-auto px-4 py-8 border border-gray-300 shadow-md rounded-xl bg-white" ref={pdfRef}>
        <h2 className="text-3xl font-semibold mb-8 bg-gradient-to-r from-purple-500 via-pink-500 to-yellow-500 bg-clip-text text-transparent text-center">
          Generated Itinerary!
        </h2>
        <div className="bg-gray-100 p-6 rounded-xl mb-8">
          <div className="flex items-center mb-8">
            <span className="inline-flex items-center rounded-md bg-blue-50 px-3 py-1 text-sm font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10 mr-4">
              {itineraryData.state.destination}
            </span>
            <span className="inline-flex items-center rounded-md bg-red-50 px-3 py-1 text-sm font-medium text-red-700 ring-1 ring-inset ring-red-600/10">
              {itineraryData.state.numberOfDays} Days
            </span>
            <span className='flex absolute right-8'>
              <MdFileDownload style={{ height: 24, width: 24, cursor: 'pointer' }} onClick={downloadPDF} />
            </span>
          </div>
          {itineraryData.state.days.map((day, index) => (
            <div key={index} className="mb-8">
              <h3 className="text-2xl font-semibold mb-4">{day.timePeriod}</h3>
              {day.activities.map((activity, activityIndex) => (
                <div key={activityIndex} className="flex flex-col sm:flex-row items-center mb-4">
                  <div className="flex-none mr-4 mb-4 sm:mb-0">
                    <ActivityWithImage activity={activity} />
                  </div>
                  <div className="flex-grow">
                    <p className="text-lg font-semibold">{activity.name}</p>
                    <p className="text-gray-600">{activity.description}</p>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
        <div className="flex justify-center mt-4">
          <button onClick={openDialog} className="bg-gray-200 p-2 rounded-full shadow-md hover:bg-gray-300 transition duration-300 ease-in-out">
            <FaShareAlt className="text-2xl text-gray-700" />
          </button>
        </div>
        {isDialogOpen && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-6 rounded-lg shadow-lg transform transition-transform duration-300 ease-in-out scale-100">
              <div className="flex justify-between items-center px-4 mb-4">
                <h3 className="text-lg font-semibold mr-4">Share Itinerary</h3>
                <button onClick={closeDialog} className="text-gray-600 hover:text-gray-800">
                  <FaTimes className="text-xl" />
                </button>
              </div>
              <div className="flex flex-col items-center space-y-4">
                <FacebookShareButton url={window.location.href} quote={shareContent()} className="flex items-center space-x-2">
                  <FaFacebookF className="text-blue-600 text-3xl" />
                  <span className="text-lg font-medium">Facebook</span>
                </FacebookShareButton>
                <TwitterShareButton url={window.location.href} title={shareTwitter()} className="flex items-center space-x-2">
                  <FaTwitter className="text-blue-400 text-3xl" />
                  <span className="text-lg font-medium">Twitter</span>
                </TwitterShareButton>
                <WhatsappShareButton url={window.location.href} title={shareContent()} className="flex items-center space-x-2">
                  <FaWhatsapp className="text-green-400 text-3xl" />
                  <span className="text-lg font-medium">WhatsApp</span>
                </WhatsappShareButton>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
